<template>
  <div class="menu-wrapper">
    <!-- <el-menu default-active="1-4-1" class="menu" :collapse="isCollapse">
    <el-submenu v-for="(submenu, index) in menus" :key="index" :index="index">
      <template slot="title">
        <i :class="submenu.meta.icon"></i>
        <span> {{ submenu.meta.title }}</span>
      </template>
      <template v-for="(menu, index) in submenu.children">
        <el-menu-item :key="index" :index="menu.path">
          <i :class="menu.meta.icon"></i>
          <span>{{ menu.meta.title }}</span>
        </el-menu-item>
      </template>
    </el-submenu>
  </el-menu> -->
    <el-menu
      :default-active="activeMenuPath"
      :collapse="isCollapse"
      @select="chooseMenu"
      class="sidebar-menu"
    >
      <div v-for="(item, index) in menus" :key="index" class="aside-menu">
        <el-menu-item
          :index="item.path"
          v-if="item.children == '' || item.children == undefined"
        >
          <i :class="item.meta.icon"></i>
          <span>{{ item.meta.title }}</span>
        </el-menu-item>
        <el-submenu v-else-if="item.children" :index="'' + index">
          <template slot="title">
            <i :class="item.meta.icon"></i>
            <span>{{ item.meta.title }}</span>
          </template>
          <el-menu-item
            v-for="(item_menu, idx) in item.children"
            :key="idx"
            :index="item_menu.path"
          >
            <span>{{ item_menu.meta.title }}</span>
          </el-menu-item>
        </el-submenu>
      </div>
    </el-menu>
    <!-- 固定在底部的版本与折叠按钮 -->
    <div class="collapse-button-wrapper" :class="{ collapsed: isCollapse }">
      <div v-show="!isCollapse" class="app-version">v{{ appVersion }}</div>
      <div class="collapse-button" @click="toggleCollapse">
        <i :class="isCollapse ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"></i>
      </div>
    </div>
  </div>
</template>
<script>
import { APP_VERSION } from '@/config/version.js'

function readOrgList() {
  try {
    const list = JSON.parse(localStorage.getItem("orgList") || "[]");
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
}

export default {
  name: 'LayoutSlider',
  props: {
    isCollapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menus: [],
      orgList: [],
      appVersion: APP_VERSION,
    };
  },
  computed: {
    // 智能计算当前应该激活的菜单路径
    activeMenuPath() {
      const currentPath = this.$route.path;
      
      // 首先尝试精确匹配
      const exactMatch = this.findMenuByPath(currentPath);
      if (exactMatch) {
        return currentPath;
      }
      
      // 如果没有精确匹配，尝试找到父路径
      const parentPath = this.findParentMenuPath(currentPath);
      return parentPath || currentPath;
    }
  },
  created() {
    this.orgList = readOrgList();
    this.orgList.forEach((element) => {
      if (element.orgId == localStorage.getItem("currentOrgId")) {
        this.menus = element.menu;
      }
    });
  },
  mounted() {
    // 添加对 localStorage 的监听
    window.addEventListener("setItem", () => {
      if (!Array.isArray(this.orgList)) return;
      this.orgList.forEach((element) => {
        if (element.orgId == localStorage.getItem("currentOrgId")) {
          this.menus = element.menu;
          this.$router.push("/welcome");
        }
      });
    });
  },
  watch: {},
  methods: {
    chooseMenu(index) {
      console.log(index);
      this.$router.push(index);
    },
    toggleCollapse() {
      this.$emit("toggle-collapse");
    },
    
    // 在菜单中查找指定路径的菜单项
    findMenuByPath(path) {
      for (const menu of this.menus) {
        if (menu.path === path) {
          return menu;
        }
        // 如果有子菜单，也要检查子菜单
        if (menu.children && menu.children.length > 0) {
          for (const child of menu.children) {
            if (child.path === path) {
              return child;
            }
          }
        }
      }
      return null;
    },
    
    // 查找当前路径的父菜单路径
    findParentMenuPath(currentPath) {
      // 定义子路径和父路径的映射关系
      const pathMapping = {
        '/home/additionalItems': '/home',
        '/store/orders': '/store',
        '/system/todos': '/system',
        '/system/stat': '/system', 
        '/system/dayStat': '/system',
        '/system/activityUvRank': '/system',
        '/system/events': '/system',
        '/system/users': '/system',
        '/system/orgs': '/system',
        '/system/apiTest': '/system',
        '/system/kevent-detail': '/system',
        '/minapp/setting': '/minapp',
        '/stat/month': '/stat',
        '/fans/list': '/fans',
        '/management/createMenu': '/management',
        '/management/editMenu': '/management'
      };
      
      // 首先检查预定义的映射
      if (pathMapping[currentPath]) {
        return pathMapping[currentPath];
      }
      
      // 如果没有预定义映射，尝试通过路径结构推断
      // 例如：/home/additionalItems -> /home
      const pathSegments = currentPath.split('/');
      if (pathSegments.length > 2) {
        const possibleParentPath = '/' + pathSegments[1];
        if (this.findMenuByPath(possibleParentPath)) {
          return possibleParentPath;
        }
      }
      
      return null;
    }
  },
};
</script>
<style lang="scss">
.menu-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}

.sidebar-menu {
  background: transparent !important;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 72px; // 为底部版本与折叠按钮留出空间
}

.aside-menu {
  width: 100%;
  .el-menu-item,
  .el-submenu__title {
    height: 40px !important;
    line-height: 40px !important;
  }
  li {
    width: 100%;
    text-align: left;
  }
}

// 折叠时隐藏所有文字
.sidebar-menu.el-menu--collapse {
  // 隐藏所有菜单项和子菜单标题中的文字
  span {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    width: 0 !important;
    height: 0 !important;
    overflow: hidden !important;
  }
  
  // 确保所有层级的文字都被隐藏
  .el-menu-item span,
  .el-submenu__title span,
  .el-submenu .el-menu-item span {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
  }
}

.collapse-button-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 180px;
  height: 72px;
  background-color: #f9fafc;
  border-top: 1px solid #ebebeb;
  display: flex;
  flex-direction: column;
  transition: width 0.3s;
  z-index: 10;
  
  &.collapsed {
    width: 64px;
    height: 48px;
  }
}

.app-version {
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 11px;
  color: #909399;
  user-select: all;
}

.collapse-button {
  flex: 1;
  width: 100%;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #606266;
  transition: all 0.3s;
  
  &:hover {
    background-color: #ecf5ff;
    color: #409eff;
  }
  
  i {
    font-size: 16px;
  }
}
</style>
